import styled from 'styled-components';
import { FunctionColor } from '@lux/tokens';
export const TextWrapper = styled.div `
    a {
        color: ${FunctionColor.function100};
        text-decoration: underline;
    }
`;
//# sourceMappingURL=styles.js.map